/**
 * Site configuration for SEO and metadata.
 * Set REACT_APP_SITE_URL in .env for production (e.g. https://yoursite.web.app)
 */
export const SITE_URL =
  process.env.REACT_APP_SITE_URL ||
  (typeof window !== "undefined" ? window.location.origin : "");
export const SITE_NAME = "Musang King Empire 猫山王朝";
export const SITE_NAME_EN = "Musang King Empire";
export const DEFAULT_DESCRIPTION =
  "馬來西亞頂級貓山王榴槤批發零售｜鮮果、急凍產品｜香港直送｜每週新鮮空運到港。";
export const DEFAULT_KEYWORDS =
  "貓山王,榴槤,馬來西亞榴槤,D197,黑刺,D24,榴槤批發,榴槤零售,急凍榴槤,榴槤泥,香港";

/** Long-tail keywords for content and category pages */
export const KEYWORDS_LONGTAL = [
  "貓山王香港",
  "貓山王批發香港",
  "急凍榴槤香港",
  "D197貓山王",
  "黑刺榴槤",
  "榴槤泥批發",
  "貓山王蛋糕",
  "貓山王鮮果",
  "D24蘇丹王",
];
